<div class="navigation">
  <span class="navigation__header">NAVIGATION</span>
  @for (tab of tabs; track tab) {
    <span
      id="{{tab}}"
      class="navigation__tab"
      (click)="tabClick(tab)">
      {{tab}}
    </span>
  }
</div>
